// client/src/api/catalog.js
// CRA-style env. If blank, we call the same origin (use CRA "proxy" in package.json).
import { API_BASE } from "../utils/env";

export async function fetchCatalog() {
  const url = `${API_BASE}/api/catalog`; // ← use the CRA env or same-origin
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await res.json();

  if (!json.ok) throw new Error(json.message || "catalog_failed");

  return json.products; // server already returns the Stripe-only shape
}
